import { isAxiosError } from 'axios';
import { apiClient } from '@/axios';
import { Endpoints } from '@/enums';

type GetDetailedStockArgs = {
  numero: string;
  marca: string;
  dispatcherTaxId: string;
};

type GetDetailedStockResponse = {
  state: number;
  value: { mensaje: string; ok: boolean };
};

export const generateANPImport = async ({
  marca,
  numero,
  dispatcherTaxId,
}: GetDetailedStockArgs): Promise<GetDetailedStockResponse> => {
  try {
    const res = await apiClient.post<GetDetailedStockResponse>(
      Endpoints.ANPImport,
      {
        marca,
        numero,
        rut: dispatcherTaxId,
      }
    );
    return res.data;
  } catch (error) {
    if (isAxiosError(error)) {
      throw new Error(error.message);
    }
    throw error;
  }
};
